<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="vehicleTable"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      fullWidth="true"

                      @rowEdit="pushToEdit($event.item)">

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.vehiclesThat', 1)"
                                label-for="input-company">
                    <model-list-select id="input-company"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="possessionOptions && possessionOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="possessionFilter"
                                       :list="possessionOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4" v-show="possessionFilter">
                  <b-form-group :label="$tc('message.from', 1)"
                                label-for="start">
                    <b-input-group>
                      <flat-pickr id="start"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="expDateStart"
                                  :config="expDateStartConfig">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button @click="expDateStart = null"
                                  :disabled="!expDateStart">
                          <font-awesome-icon icon="trash" />
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4" v-show="possessionFilter">
                  <b-form-group :label="$tc('message.to', 1)"
                                label-for="end">
                    <b-input-group>
                      <flat-pickr id="end"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="expDateEnd"
                                  :config="expDateEndConfig">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button @click="expDateEnd = null"
                                  :disabled="!expDateEnd">
                          <font-awesome-icon icon="trash" />
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.brand', 1)}`"
                                label-for="input-brand">
                    <model-list-select id="input-brand"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="brandOptions && brandOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="brandFilter"
                                       :list="brandOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.model', 1)"
                                label-for="input-model">
                    <model-list-select id="input-model"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="modelOptions && modelOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="modelFilter"
                                       :list="modelOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="2" xl="2">
                  <b-form-group :label="$t('message.inOperation')"
                                label-for="input-removed">
                    <model-list-select id="input-removed"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="removedOptions && removedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="removedFilter"
                                       :list="removedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                label-for="input-activity-sector">
                    <model-list-select id="input-activity-sector"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="activitySectorFilter"
                                       :list="activitySectorOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-corp">
                    <model-list-select id="input-corp"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="companyFilter"
                                       :list="companyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.property', 1)}`"
                                label-for="input-owner">
                    <model-list-select id="input-owner"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownerFilter"
                                       :list="ownerOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$t('message.vehicleUsage')"
                                label-for="input-removegd">
                    <model-list-select id="input-removegd"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownershipTypeOptions && ownershipTypeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownershipTypeFilter"
                                       :list="ownershipTypeOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.status', 1)} ${$tc('message.vehicle', 1).toLowerCase()}`"
                                label-for="input-state-vehicle">
                    <model-list-select id="input-state-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="vehicleStateOptions && vehicleStateOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="vehicleStateFilter"
                                       :list="vehicleStateOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$t('message.maxWeight')}`"
                                label-for="input-maxWeight">
                    <model-list-select id="input-maxWeight"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="maxWeightOption && maxWeightOption.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="maxWeightFilter"
                                       :list="maxWeightOption">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="1" xl="1">
                  <b-form-group label="Kg"
                                label-for="input-kg">
                    <b-form-input id="input-kg"
                                  v-model="kg"
                                  autocomplete="off" type="number"
                                  :placeholder="`${$tc('message.example', 1)}: 7500`">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="getExcel()">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { find, capitalize, cloneDeep, filter, sortBy, orderBy, trim, last, concat } from 'lodash'
import { Italian } from 'flatpickr/dist/l10n/it.js'

export default {
  name: 'RepoInsurance',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getStaticOptions()
        this.updateLinks()
      }
    })
  },
  data () {
    const genericDateOptions = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      insuranceCompanyOptions: [],
      originalItems: [],
      items: [],
      fields: [],
      trackers: [],
      customFields: [],
      itemsList: [],
      // filters
      activitySectorOptions: [],
      activitySectorFilter: '',
      companyOptions: [],
      companyFilter: '',
      ownerOptions: [],
      ownerFilter: '',
      vehicleStateOptions: [],
      vehicleStateFilter: '',
      serviceTypeOptions: [],
      serviceTypeFilter: '',
      ownershipTypeOptions: [],
      ownershipTypeFilter: '',
      wasteOptions: [],
      removedOptions: [],
      removedFilter: '',
      possessionOptions: [],
      possessionFilter: '',
      obuOption: [],
      obuFilter: '',
      brandOptions: [],
      brandFilter: '',
      modelOptions: [],
      modelFilter: '',
      maxWeightOption: [],
      maxWeightFilter: true,
      kg: 0,
      hasInsuranceOptions: [],
      paymentOptions: [],
      expDateStart: null,
      expDateEnd: null,
      expDateStartConfig: cloneDeep(genericDateOptions),
      expDateEndConfig: cloneDeep(genericDateOptions),
      insuranceCompanyFilter: null,
      links: [
        '/configuration/activity_sector',
        '/configuration/company',
        '/configuration/owner',
        '/configuration/vehicle_state',
        '/configuration/service_type'
      ],
      showCollapse: true
    }
  },
  watch: {
    possessionFilter (val) {
      this.items = this.getItems(val, 'possessionFilter')
      this.getFields()
    },
    expDateStart (val) {
      const parsedVal = new Date(val)
      this.items = this.getItems(val, 'expDateStart')

      this.expDateEndConfig.disable = [dateObj => {
        return val ? dateObj < parsedVal : false
      }]
    },
    expDateEnd (val) {
      const parsedVal = new Date(val)
      this.items = this.getItems(val, 'expDateEnd')

      this.expDateStartConfig.disable = [dateObj => {
        return val ? dateObj > parsedVal : false
      }]
    },
    removedFilter (val) {
      this.items = this.getItems(val, 'removedFilter')
    },
    obuFilter (val) {
      this.items = this.getItems(val, 'obuFilter')
    },
    activitySectorFilter (val) {
      this.items = this.getItems(val, 'activitySectorFilter')
    },
    companyFilter (val) {
      this.items = this.getItems(val, 'companyFilter')
    },
    ownerFilter (val) {
      this.items = this.getItems(val, 'ownerFilter')
    },
    vehicleStateFilter (val) {
      this.items = this.getItems(val, 'vehicleStateFilter')
    },
    ownershipTypeFilter (val) {
      this.items = this.getItems(val, 'ownershipTypeFilter')
    },
    brandFilter (val) {
      this.items = this.getItems(val, 'brandFilter')
    },
    modelFilter (val) {
      this.items = this.getItems(val, 'modelFilter')
    },
    maxWeightFilter (val) {
      this.items = this.getItems(val, 'maxWeightFilter')
    },
    kg (val) {
      this.items = this.getItems(val, 'kg')
    }
  },
  methods: {
    clickedLink (link) {
      if (link.href) {
        this.$router.push(link.href)
      }
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getOptions().then(() => this.getVehicles().then(() => {
        this.expDateStart = DateTime.local().set({ hours: 0, minutes: 0, seconds: 0 }).toSQLDate()
        this.expDateEnd = DateTime.local().set({ hours: 0, minutes: 0, seconds: 0 }).plus({ months: 6 }).toSQLDate()
        this.updateLinks()
      }))
    },
    getOptions () {
      const axiosArray = []
      this.getStaticOptions()
      axiosArray.push(this.getTrackers())
      axiosArray.push(this.getEnum('owner', 'ownerOptions'))
      axiosArray.push(this.getEnum('fuel_type', 'fuelsOptions'))
      axiosArray.push(this.getEnum('company', 'companyOptions'))
      axiosArray.push(this.getEnum('equipment', 'equipmentOptions'))
      axiosArray.push(this.getEnum('vehicle_state', 'vehicleStateOptions'))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions'))
      axiosArray.push(this.getEnum('service_type', 'serviceTypeOptions'))
      axiosArray.push(this.getEnum('classification', 'classificationOptions'))
      axiosArray.push(this.getEnum('registry_code', 'wasteOptions'))
      axiosArray.push(this.getEnum('insurance_company', 'insuranceCompanyOptions'))
      return Vue.myAll(axiosArray).then(r => r)
    },
    getStaticOptions () {
      this.getFields()
      this.getObuOption()
      this.getWeightOptions()
      this.getRemovedOptions()
      this.getOwnershipTypeOptions()
      this.getHasInsuranceOptions()
      this.getPaymentOptions()
      this.getPossessionOptions()
      this.updateLinks()
    },
    getFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeBrand', label: this.$tc('message.brand', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeModel', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' },
        { key: 'traction', label: this.$tc('message.maxWeight', 1), sortable: true, sortDirection: 'desc' },
        { key: 'number', label: `${this.$tc('message.number', 1)} ${this.$tc('message.insurance', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'descr', label: this.$tc('message.insuranceCompany', 1), sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'price', label: this.$tc('message.price', 1), sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'parsedStartDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.start').toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'parsedEndDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.expiration').toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'parsedPaymentFrequency', label: `${this.$t('message.frequency')} ${this.$t('message.payment').toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: !this.possessionFilter, hideInExcel: !this.possessionFilter },
        { key: 'disabledText', label: `${this.$t('message.inOperation')}`, sortable: true, sortDirection: 'desc' }
      ]
    },
    getObuOption () {
      this.obuOption = [
        { value: '', text: this.$t('message.all') },
        { value: true, text: this.$t('message.yes') },
        { value: false, text: this.$t('message.no') }
      ]
    },
    getWeightOptions () {
      this.maxWeightOption = [
        { value: true, text: this.$tc('message.equalOrMore', 1) },
        { value: false, text: this.$tc('message.equalOrLess', 1) }
      ]
    },
    getRemovedOptions () {
      this.removedOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: false, text: this.$tc('message.yes', 1) },
        { value: true, text: this.$tc('message.no', 1) }
      ]
    },
    getOwnershipTypeOptions () {
      this.ownershipTypeOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: 'rental', text: this.$tc('message.rental', 1) },
        { value: 'leasing', text: 'Leasing' },
        { value: 'property', text: this.$tc('message.property', 1) },
        { value: 'loan', text: this.$tc('message.loan', 1) }
      ]
    },
    getHasInsuranceOptions () {
      this.hasInsuranceOptions = [
        { value: '', text: this.$t('message.all') },
        { value: false, text: this.$t('message.yes') },
        { value: true, text: this.$t('message.no') }
      ]
    },
    getPaymentOptions () {
      this.paymentOptions = [
        { value: 1, text: this.$t('message.monthly') },
        { value: 3, text: this.$t('message.quarterly') },
        { value: 6, text: this.$t('message.semiannual') },
        { value: 12, text: this.$t('message.yearly') }
      ]
    },
    getPossessionOptions () {
      this.possessionOptions = [
        { value: true, text: `${this.$tc('message.has', 1)} ${this.$tc('message.insurance', 2).toLowerCase()}` },
        { value: '', text: `${this.$tc('message.hasNot', 1)} ${this.$tc('message.insurance', 2).toLowerCase()}` }
      ]
    },
    getTrackers () {
      return Vue.myGet(this, '/trackers', 'trackers').then((items) => {
        this.trackers = items
        return true
      })
    },
    getEnum (path, obj) {
      const options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({ value: '', text: items.length !== 0 ? this.$t('message.all') : this.$t('message.noOption') })
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicles () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then(vehicles => {
        const editedVehicles = []
        const options = {
          activitySectorOptions: this.activitySectorOptions,
          ownerOptions: this.ownerOptions,
          ownershipTypeOptions: this.ownershipTypeOptions,
          vehicleStateOptions: this.vehicleStateOptions,
          companyOptions: this.companyOptions,
          classificationOptions: this.classificationOptions,
          fuelsOptions: this.fuelsOptions,
          equipmentOptions: this.equipmentOptions,
          trackers: this.trackers
        }
        const brandOptions = new Set()
        const modelOptions = new Set()
        const editedBrands = [{ text: this.$tc('message.all', 1), value: '' }]
        const editedModels = [{ text: this.$tc('message.all', 1), value: '' }]

        vehicles.forEach(vehicle => {
          if (vehicle.type && vehicle.type.brand) brandOptions.add(trim(vehicle.type.brand.toLocaleLowerCase()))
          if (vehicle.type && vehicle.type.model) modelOptions.add(trim(vehicle.type.model.toLocaleLowerCase()))

          const editedVehicle = this.assembleVehicle(vehicle, options)
          editedVehicle.services = vehicle.services || null
          editedVehicle.insurances = vehicle.insurances || null
          editedVehicles.push(editedVehicle)
        })

        Array.from(brandOptions).forEach((brand, index) => {
          editedBrands.push({ text: brand, value: index })
        })
        Array.from(modelOptions).forEach((model, index) => {
          editedModels.push({ text: model, value: index })
        })

        this.brandOptions = orderBy(editedBrands, 'text')
        this.modelOptions = orderBy(editedModels, 'text')

        this.originalItems = sortBy(editedVehicles, o => capitalize(o.plateNumber))
        this.$root.$emit('activeLoader', false)
        return cloneDeep(this.originalItems)
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return []
      })
    },
    assembleVehicle (vehicle, options) {
      let newVehicle = this.getMainVehicleData(vehicle, options)
      newVehicle = this.getExtraData(vehicle, newVehicle, options)
      newVehicle = this.getVehicleUsage(vehicle, newVehicle, options)
      newVehicle = this.getVehicleOBU(vehicle, newVehicle)
      return newVehicle
    },
    getMainVehicleData (vehicle, options) {
      const classification = find(options.classificationOptions, obj => vehicle.type && vehicle.type.classification !== null && obj.value === vehicle.type.classification)
      const fuel = find(options.fuelsOptions, obj => vehicle.type && vehicle.type.fuelType !== null && obj.value === vehicle.type.fuelType)
      const equipment = find(options.equipmentOptions, obj => vehicle.type && vehicle.type.equipment !== null && obj.value === vehicle.type.equipment)

      return {
        id: vehicle.id,
        name: `${vehicle.plateNumber} ${(vehicle.type && vehicle.type.brand) || ''} ${(vehicle.type && vehicle.type.model) || ''}`,
        plateNumber: vehicle.plateNumber,
        typeBrand: (vehicle.type && vehicle.type.brand) || '',
        typeModel: (vehicle.type && vehicle.type.model) || '',
        registrationDate: vehicle.registrationDate,
        classification: classification && classification.text,
        classificationValue: classification && classification.value,
        chassisNumber: vehicle.chassisNumber,
        payload: vehicle.type && vehicle.type.payload,
        engineDisplacement: vehicle.type && vehicle.type.engineDisplacement,
        kw: vehicle.type && vehicle.type.kw,
        fuel: fuel && fuel.text,
        fuelValue: fuel && fuel.value,
        seats: vehicle.type && vehicle.type.seats,
        emissionStandard: vehicle.type && vehicle.type.emissionStandard,
        trailerHitch: vehicle.type && vehicle.type.trailerHitch ? this.$t('message.yes') : this.$t('message.no'),
        equipment: equipment && equipment.text,
        equipmentValue: equipment && equipment.value,
        imei: vehicle.imei
      }
    },
    getExtraData (oldVehicle, vehicle, options) {
      const activitySector = find(options.activitySectorOptions, obj => obj.value === oldVehicle.activitySector && oldVehicle.activitySector !== null)
      const property = find(options.ownerOptions, obj => oldVehicle.ownership && obj.value === oldVehicle.ownership.owner && oldVehicle.ownership.owner !== null)
      const state = find(options.vehicleStateOptions, obj => obj.value === oldVehicle.state && oldVehicle.state !== null)
      const userCompany = find(options.companyOptions, obj => obj.value === oldVehicle.userCompany && oldVehicle.userCompany !== null)
      const measures = oldVehicle.measures && oldVehicle.measures.length && oldVehicle.measures.length !== 0 ? last(oldVehicle.measures) : {}

      vehicle.disabledText = oldVehicle.disablingDate ? this.$t('message.no') : this.$t('message.yes')
      vehicle.disabledDate = oldVehicle.disablingDate ? oldVehicle.disablingDate : this.$t('message.noDate')
      vehicle.disabledValue = !!oldVehicle.disablingDate
      vehicle.stateText = state && state.text
      vehicle.stateValue = state && state.value
      vehicle.property = property && property.text
      vehicle.propertyValue = property && property.value
      vehicle.userCompanyText = userCompany && userCompany.text
      vehicle.userCompanyValue = userCompany && userCompany.value
      vehicle.activitySectorText = activitySector && activitySector.text
      vehicle.activitySectorValue = activitySector && activitySector.value
      vehicle.kmCost = oldVehicle.kmCost
      vehicle.avgConsumption = oldVehicle.avgConsumption
      vehicle.lengthCm = oldVehicle.type && oldVehicle.type.length
      vehicle.widthCm = oldVehicle.type && oldVehicle.type.width
      vehicle.traction = oldVehicle.type && oldVehicle.type.traction // was changed in maxWeight
      vehicle.lastKm = measures && measures.km
      vehicle.lastDate = measures && measures.date
      vehicle.automathicKm = oldVehicle.estimatedKm
      vehicle.automathicDate = `${DateTime.local().plus({ days: -1 }).toSQLDate()} 00:00:00`
      vehicle.description = oldVehicle.description
      return cloneDeep(vehicle)
    },
    getVehicleUsage (oldVehicle, vehicle, options) {
      const ownershipObj = this.getOwnershipType(cloneDeep(oldVehicle.ownership), options)
      const rental = oldVehicle.ownership && oldVehicle.ownership.rental
      const leasing = oldVehicle.ownership && oldVehicle.ownership.leasing
      const purchase = oldVehicle.ownership && oldVehicle.ownership.purchase
      vehicle.ownership = ownershipObj && ownershipObj.name
      vehicle.ownershipValue = ownershipObj && ownershipObj.ownershipValue
      vehicle.rentalStart = rental && rental.startDate && rental.type !== 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.rentalEnd = rental && rental.endDate && rental.type !== 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.loanStart = rental && rental.startDate && rental.type === 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.loanEnd = rental && rental.endDate && rental.type === 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.leasingStart = leasing && leasing.startDate ? leasing.startDate : this.$t('message.noDate')
      vehicle.leasingEnd = leasing && leasing.endDate ? leasing.endDate : this.$t('message.noDate')
      vehicle.purchaseDate = purchase && purchase.date ? purchase.date : null
      vehicle.company = rental && rental.company
      vehicle.rentalPrice = rental && rental.price
      vehicle.rentalRedemptionPrice = rental && rental.redemptionPrice
      vehicle.relief = rental && rental.relief
      vehicle.kmYear = rental && rental.kmYear
      vehicle.maxKm = rental && rental.maxKm
      vehicle.loanerVehicle = rental && rental.type === 'loan' ? this.$t('message.yes') : this.$t('message.no')
      vehicle.towTruck = rental && rental.towTruck ? this.$t('message.yes') : this.$t('message.no')
      vehicle.leasingRedemptionPrice = leasing && leasing.redemptionPrice
      vehicle.purchasePrice = purchase && purchase.price
      vehicle.purchaseKm = purchase && purchase.km
      return cloneDeep(vehicle)
    },
    getOwnershipType (ownership, options) {
      if (ownership) {
        let name = null
        const rentalType = ownership.rental && ownership.rental.type
        const rentalStart = ownership.rental && ownership.rental.startDate && DateTime.fromSQL(ownership.rental.startDate)
        const leasingStart = ownership.leasing && ownership.leasing.startDate && DateTime.fromSQL(ownership.leasing.startDate)
        const rentalEnd = ownership.rental && ownership.rental.endDate && DateTime.fromSQL(ownership.rental.endDate)
        const leasingEnd = ownership.leasing && ownership.leasing.endDate && DateTime.fromSQL(ownership.leasing.endDate)
        const purchaseStart = ownership.purchase && ownership.purchase.date && DateTime.fromSQL(ownership.purchase.date)
        let ownershipValue = null
        if (purchaseStart) name = this.$tc('message.property', 1)
        if (!name && rentalEnd > leasingEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (!name && leasingEnd > rentalEnd) name = 'Leasing'
        if (!name && leasingEnd) name = 'Leasing'
        if (!name && rentalEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (name) {
          ownershipValue = find(options.ownershipTypeOptions, obj => obj.text === name).value
        }
        return {
          ownershipValue,
          name,
          rentalStart,
          rentalEnd,
          leasingStart,
          leasingEnd,
          purchaseDate: purchaseStart
        }
      }
      return null
    },
    getVehicleOBU (oldVehicle, vehicle) {
      const vehicleTracker = find(this.trackers, obj => vehicle.imei !== '' && !!vehicle.imei && !!obj.imei && obj.imei === vehicle.imei)
      vehicle.vehicleTracker = vehicleTracker ? vehicleTracker.serialNumber : this.$tc('message.emptyValue', 1)
      return cloneDeep(vehicle)
    },
    getItems (value, field) {
      const start = field === 'expDateStart' ? (value ? DateTime.fromSQL(value) : null) : (this.expDateStart ? DateTime.fromSQL(this.expDateStart) : null)
      const end = field === 'expDateEnd' ? (value ? DateTime.fromSQL(value) : null) : (this.expDateEnd ? DateTime.fromSQL(this.expDateEnd) : null)
      const possessionFilter = field === 'possessionFilter' ? value : this.possessionFilter
      const activitySector = field === 'activitySectorFilter' ? value : this.activitySectorFilter
      const company = field === 'companyFilter' ? value : this.companyFilter
      const owner = field === 'ownerFilter' ? value : this.ownerFilter
      const vehicleState = field === 'vehicleStateFilter' ? value : this.vehicleStateFilter
      const ownershipType = field === 'ownershipTypeFilter' ? value : this.ownershipTypeFilter
      const removed = field === 'removedFilter' ? value : this.removedFilter
      const obu = field === 'obuFilter' ? value : this.obuFilter
      const brand = field === 'brandFilter' ? value : this.brandFilter
      const model = field === 'modelFilter' ? value : this.modelFilter
      const maxWeight = field === 'maxWeightFilter' ? value : this.maxWeightFilter
      const kg = field === 'kg' ? parseInt(value) : parseInt(this.kg)
      let editedItems = cloneDeep(this.originalItems)

      if (activitySector && activitySector !== '') {
        editedItems = filter(editedItems, obj => obj.activitySectorValue === find(this.activitySectorOptions, obj => obj.value === activitySector).value)
      }
      if (company && company !== '') {
        editedItems = filter(editedItems, obj => obj.userCompanyValue === find(this.companyOptions, obj => obj.value === company).value)
      }
      if (owner && owner !== '') {
        editedItems = filter(editedItems, obj => obj.propertyValue === find(this.ownerOptions, obj => obj.value === owner).value)
      }
      if (vehicleState && vehicleState !== '') {
        editedItems = filter(editedItems, obj => obj.stateValue === find(this.vehicleStateOptions, obj => obj.value === vehicleState).value)
      }
      if (ownershipType && ownershipType !== '') {
        editedItems = filter(editedItems, obj => obj.ownershipValue === find(this.ownershipTypeOptions, obj => obj.value === ownershipType).value)
      }
      if (removed !== '') {
        editedItems = filter(editedItems, obj => obj.disabledValue === removed)
      }
      if (obu !== '') {
        editedItems = filter(editedItems, obj => obu
          ? (obj.vehicleTracker && obj.vehicleTracker !== this.$tc('message.emptyValue', 1))
          : (!obj.vehicleTracker || obj.vehicleTracker === this.$tc('message.emptyValue', 1)))
      }
      if (brand !== '') {
        const foundedBrand = find(this.brandOptions, obj => obj.value === brand)
        editedItems = filter(editedItems, obj => obj.typeBrand ? trim(obj.typeBrand.toLowerCase()) === trim(foundedBrand.text.toLowerCase()) : false)
      }
      if (model !== '') {
        const foundedModel = find(this.modelOptions, obj => obj.value === model)
        editedItems = filter(editedItems, obj => obj.typeModel ? trim(obj.typeModel.toLowerCase()) === trim(foundedModel.text.toLowerCase()) : false)
      }
      if (maxWeight === true && kg !== 0) {
        editedItems = filter(editedItems, obj => obj.traction ? obj.traction >= kg && !isNaN(kg) : false)
      } else if (maxWeight === false) {
        editedItems = filter(editedItems, obj => obj.traction ? obj.traction <= kg && !isNaN(kg) : false)
      }

      if (!possessionFilter) return filter(editedItems, o => !o.insurances || o.insurances.length === 0)
      editedItems = filter(editedItems, obj => {
        const insurances = sortBy(obj.insurances, item => DateTime.fromSQL(item.endDate).ts)
        let foundedInsurance = false

        obj.foundedInsurance = null
        obj.number = this.$tc('message.emptyValue', 1)
        obj.descr = this.$tc('message.emptyValue', 1)
        obj.price = ''
        obj.parsedPaymentFrequency = this.$tc('message.emptyValue', 1)
        obj.parsedStartDate = this.$tc('message.emptyValue', 1)
        obj.parsedEndDate = this.$tc('message.emptyValue', 1)

        insurances.forEach(item => {
          const date = DateTime.fromSQL(item.endDate)

          if (date && date >= start && date <= end) {
            foundedInsurance = item
          }
        })

        if (foundedInsurance) {
          const foundedPaymentFreq = find(this.paymentOptions, obj => parseInt(obj.value) === parseInt(foundedInsurance.paymentFreq))
          const insuranceName = find(this.insuranceCompanyOptions, obj => obj.value === foundedInsurance.company)

          obj.foundedInsurance = foundedInsurance

          obj.number = foundedInsurance.number
          obj.descr = insuranceName ? insuranceName.text : ''
          obj.price = foundedInsurance.price || ''
          obj.parsedPaymentFrequency = foundedPaymentFreq ? foundedPaymentFreq.text : this.$tc('message.emptyValue', 1)
          obj.parsedStartDate = DateTime.fromSQL(foundedInsurance.startDate).toFormat('dd-MM-yyyy')
          obj.parsedEndDate = DateTime.fromSQL(foundedInsurance.endDate).toFormat('dd-MM-yyyy')
        }

        return obj.foundedInsurance ? obj : false
      })

      this.getFields()
      return editedItems
    },
    pushToEdit (item) {
      item && item.id ? this.$router.push({
        name: 'EditVehicle', params: { id: item.id }, query: { tab: 'insurance' }
      }) : this.$router.push({
        name: 'EditVehicle', params: { id: 'new' }
      })
    },
    resetFilters () {
      this.possessionFilter = ''
      this.expDateStart = DateTime.local().set({ hours: 0, minutes: 0, seconds: 0 }).toSQLDate()
      this.expDateEnd = DateTime.local().set({ hours: 0, minutes: 0, seconds: 0 }).plus({ months: 6 }).toSQLDate()
      this.$refs.vehicleTable.resetSearch()
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    getExcel () {
      this.getFields()
      this.$refs.vehicleTable.excel(this.$tc('message.insurance', 2))
    }
  }
}
</script>
